import { Badge } from '@mantine/core'
import { ForwardRefExoticComponent, ElementType } from 'react'
import { IconProps } from '@tabler/icons-react'
import { getResourceTypeLabel } from '@/hooks'
import { isRenderableIcon } from '@/pages/Patient/components/ChronologicalRecords.utils'

type Props = {
  count: number
  icon: ForwardRefExoticComponent<IconProps> | ElementType
  color: string
  dataKey: string
  onClick?: (e: React.MouseEvent) => void
}

export function ResourceTypeBadge({ count, icon: Icon, color, dataKey, onClick }: Props) {
  const displayLabel = getResourceTypeLabel(dataKey)

  return (
    <Badge
      size="xs"
      variant="light"
      color="gray"
      leftSection={isRenderableIcon(Icon) ? <Icon size={10} color={color} /> : null}
      onClick={onClick}
      className="cursor-pointer transition-colors hover:bg-gray-200"
      styles={{
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      }}
    >
      {count} {displayLabel}
    </Badge>
  )
}
